module.exports = __webpack_public_path__ + "static/img/12.620a44d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/eng/12.png
// module id = yGNQ
// module chunks = 0